import { createSlice } from "@reduxjs/toolkit";
import { CampaignPostsState, defaultCampaignPostsFilters } from "types/campaign/posts";
import { fetchCampaignPostsThunk } from "./thunk";
import { ERROR } from "types";

const initialState: CampaignPostsState = {
    posts: {
        loading: false,
        error: null,
        applied_filter_id: null,
        items: {},
        filters: defaultCampaignPostsFilters
    }
}

const campaignPosts = createSlice({
    name: 'campaignPosts',
    initialState,
    reducers: {
        setCampaignPostsFilters(state, action) {
            state.posts.filters = action.payload;
        }
    },
    extraReducers: ((builder) => {
        builder
            .addCase(fetchCampaignPostsThunk.pending, (state) => {
                state.posts.loading = true;
                state.posts.error = null;
            })
            .addCase(fetchCampaignPostsThunk.fulfilled, (state, action) => {
                state.posts.loading = false;
                state.posts.error = null;
                const filterId = action.payload.filterId;
                const socialAccountId = action.payload.campaignId;
                const existingData = state.posts.items?.[socialAccountId]?.filtered_lists?.[filterId]?.items ?? [];
                const finalList = action.payload.filters.page === 1 ? action.payload.items : [...existingData, ...action.payload.items];
                state.posts.items[socialAccountId] = {
                    ...state.posts.items[socialAccountId],
                    filtered_lists: {
                        ...(state.posts.items[socialAccountId]?.filtered_lists ?? {}),
                        [filterId]: {
                            items: finalList,
                            page: action.payload.filters.page,
                            expired: false,
                            last_fetched_at: Date.now(),
                            has_more: action.payload.count > finalList.length,
                            filters: action.payload.filters,
                            count: action.payload.count,
                            error: null,
                            loading: false
                        }
                    },
                    total: action.payload.count
                }
                state.posts.applied_filter_id = filterId;
            })
            .addCase(fetchCampaignPostsThunk.rejected, (state, action) => {
                state.posts.loading = false;
                if (action.payload !== ERROR.CACHED)
                    state.posts.error = action.payload || "Failed to fetch applications"
            })
    })
})

export const { setCampaignPostsFilters } = campaignPosts.actions;

export default campaignPosts.reducer;
